const IlotC_synthese_2 = require('./IlotC_synthese_2.webp');
export default [IlotC_synthese_2];
